(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const API = 'https://api.reviews.io/merchant/latest';

    // Floor rather than round: a 4.5 average should not be drawn as five full
    // stars. The exact figure is printed next to the stars anyway.
    function stars(rating) {
      const filled = Math.floor(Number(rating) || 0);
      return '★★★★★'.slice(0, filled) + '☆☆☆☆☆'.slice(0, 5 - filled);
    }

    // Review bodies and reviewer names are third-party content: always assign via
    // textContent so a review can never inject markup into the page.
    function buildCard(review) {
      const card = document.createElement('article');
      card.className = 'google-reviews__card';

      const head = document.createElement('div');
      head.className = 'google-reviews__card-head';

      const reviewer = review.reviewer || {};
      const who = document.createElement('strong');
      who.textContent = String(reviewer.first_name || 'Verified customer').trim();

      const rating = document.createElement('span');
      rating.textContent = stars(review.rating);
      rating.setAttribute('aria-label', 'Rated ' + (review.rating || 0) + ' out of 5');

      head.appendChild(who);
      head.appendChild(rating);

      const body = document.createElement('p');
      body.textContent = String(review.comments || '').trim();

      const meta = document.createElement('small');
      const bits = [];
      if (reviewer.verified_buyer === 'yes') bits.push('Verified buyer');
      if (reviewer.address) bits.push(String(reviewer.address));
      if (review.date) bits.push(String(review.date));
      meta.textContent = bits.join(' · ');

      card.appendChild(head);
      card.appendChild(body);
      card.appendChild(meta);
      return card;
    }

    document.querySelectorAll('[data-google-reviews-carousel]').forEach((carousel) => {
      const viewport = carousel.querySelector('[data-google-reviews-viewport]');
      const prev = carousel.querySelector('[data-google-reviews-prev]');
      const next = carousel.querySelector('[data-google-reviews-next]');
      const store = (carousel.dataset.reviewsStore || '').trim();
      const limit = parseInt(carousel.dataset.reviewsLimit, 10) || 6;
      if (!viewport || !store) return;

      if (prev && next) {
        const scrollByCard = (direction) => {
          const card = viewport.querySelector('.google-reviews__card');
          const amount = card ? card.getBoundingClientRect().width + 16 : 320;
          viewport.scrollBy({ left: amount * direction, behavior: 'smooth' });
        };
        prev.addEventListener('click', () => scrollByCard(-1));
        next.addEventListener('click', () => scrollByCard(1));
      }

      const params = new URLSearchParams({ store: store, per_page: String(limit) });
      fetch(API + '?' + params.toString(), { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((payload) => {
          const reviews = (payload && Array.isArray(payload.reviews) ? payload.reviews : [])
            .filter((review) => review && String(review.comments || '').trim());
          if (!reviews.length) return;

          reviews.slice(0, limit).forEach((review) => viewport.appendChild(buildCard(review)));

          // The headline figures are no longer written from this payload — the
          // badge shows the Google store rating now, and REVIEWS.io only supplies
          // the individual cards.
          carousel.hidden = false;
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Shopify's search matches every token but the last one as a whole word, so a
  // query typed with a separator — "I/N", "AD-CHL02-3/42", "sauna+heater" —
  // tokenises into terms that individually match nothing and the whole search
  // comes back empty. Normalising those separators to spaces fixes it, and the
  // wider variants below give a query one more chance before we call it empty.
  // Shared with the search results page (sections/main-search.liquid).
  window.ADSearch = window.ADSearch || (function () {
    var SEPARATORS = /[\/\\|,;+&_\u00b7\u2022]+/g;
    var SMART_QUOTES = /[\u2018\u2019\u201c\u201d]/g;

    // Customers paste item numbers with the label still attached — "I/N
    // 9362617004651" off an invoice or a competitor's listing. Shopify searches
    // the label too and finds nothing, while the bare number matches the
    // barcode. Strip the label and search what follows it.
    var CODE_LABEL = new RegExp(
      '^(?:' +
        'i\\s*/\\s*n|p\\s*/\\s*n|' +
        '(?:item|part|model|product)(?:\\s*(?:no\\.?|number|code|#))?|' +
        'sku|mpn|barcode|gtin|ean|upc' +
      ')(?:\\s*[:#.\\-]\\s*|\\s+|$)',
      'i'
    );

    function normalise(raw) {
      return String(raw == null ? '' : raw)
        .replace(SMART_QUOTES, '"')
        .replace(SEPARATORS, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function tokens(raw) {
      return normalise(raw).split(' ').filter(Boolean);
    }

    // The code after a label, or '' when the query is nothing but a label
    // ("I/N" on its own — a prompt for a number, not a search term).
    function stripLabel(raw) {
      var value = String(raw == null ? '' : raw).trim();
      var match = CODE_LABEL.exec(value);
      if (!match) return null;
      return value.slice(match[0].length).trim();
    }

    function isLabelOnly(raw) {
      return stripLabel(raw) === '';
    }

    // Progressively wider rewrites of a query, narrowest first. Only the ones
    // that differ from an earlier entry are kept, so a plain "sauna" yields a
    // single candidate and costs exactly one request.
    function candidates(raw) {
      var list = [];
      function add(value) {
        if (value && list.indexOf(value) === -1) list.push(value);
      }
      // A labelled code goes first, ahead of the query as typed: the label is
      // noise, and leaving it in matches loose junk. "Item No. AD-HRRM7-PR"
      // returns four fuzzy hits with the label, one exact hit without it.
      var code = stripLabel(raw);
      if (code) {
        add(code);
        add(normalise(code));
      }

      add(String(raw == null ? '' : raw).trim());

      // A single unspaced run punctuated with _ . / is a product code typed
      // with the wrong separator. Every SKU here is hyphenated, so try that
      // before falling back to spaces: "AD_SS_ICE_01" as "AD-SS-ICE-01" is one
      // exact hit, as "AD SS ICE 01" it is 74 loose ones.
      var solid = String(raw == null ? '' : raw).trim();
      if (solid && !/\s/.test(solid) && /[_.\/\\]/.test(solid)) {
        add(solid.replace(/[_.\/\\]+/g, '-'));
      }

      add(normalise(raw));

      var parts = tokens(raw);
      var plain = parts.length > 0 && parts.every(function (part) {
        return part.indexOf('*') === -1 && part.indexOf('"') === -1;
      });
      if (plain) {
        var prefixed = parts.map(function (part) { return part + '*'; });
        add(prefixed.join(' '));                 // every token, prefix match
        if (parts.length > 1) add(prefixed.join(' OR ')); // any token
      }
      return list;
    }

    return {
      normalise: normalise,
      tokens: tokens,
      candidates: candidates,
      stripLabel: stripLabel,
      isLabelOnly: isLabelOnly
    };
  })();

  if (!customElements.get('site-header')) {
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        const toggle = this.querySelector('[data-menu-toggle]');
        const mobileNav = this.querySelector('[data-mobile-nav]');
        const closeButtons = this.querySelectorAll('[data-menu-close]');
        if (toggle && mobileNav) {
          const closeMobileNav = () => {
            mobileNav.classList.remove('is-open');
            mobileNav.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
          };

          toggle.addEventListener('click', () => {
            const open = mobileNav.classList.toggle('is-open');
            mobileNav.hidden = !open;
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          });

          closeButtons.forEach((button) => button.addEventListener('click', closeMobileNav));
        }

        const closeDropdowns = () => {
          this.querySelectorAll('.site-header__dropdown.is-open, .site-header__mega.is-open').forEach((panel) => panel.classList.remove('is-open'));
          this.querySelectorAll('[data-dropdown-toggle][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
        };

        this.querySelectorAll('[data-dropdown-toggle]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            if (window.matchMedia('(max-width: 899px)').matches) return;
            const panel = trigger.parentElement.querySelector('.site-header__dropdown, .site-header__mega');
            if (!panel) return;
            event.preventDefault();
            const willOpen = !panel.classList.contains('is-open');
            closeDropdowns();
            if (willOpen) {
              panel.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
            }
          });
        });

        const depts = this.querySelectorAll('[data-drawer-dept]');
        const panels = this.querySelectorAll('[data-drawer-panel]');
        depts.forEach((dept) => {
          const activate = () => {
            const index = dept.dataset.drawerDept;
            depts.forEach((d) => d.classList.toggle('is-active', d.dataset.drawerDept === index));
            panels.forEach((p) => p.classList.toggle('is-active', p.dataset.drawerPanel === index));
          };
          dept.addEventListener('mouseenter', activate);
          dept.addEventListener('focus', activate);
        });

        document.addEventListener('click', (event) => {
          if (this.contains(event.target)) return;
          closeDropdowns();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closeDropdowns();
            if (toggle && mobileNav) {
              mobileNav.classList.remove('is-open');
              mobileNav.hidden = true;
              toggle.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }
    }
    customElements.define('site-header', SiteHeader);
  }

  if (!customElements.get('predictive-search')) {
    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-predictive-search-input]');
        this.results = this.querySelector('[data-predictive-search-results]');
        this.searchUrl = this.dataset.searchUrl || '/search';
        this.currency = this.dataset.shopCurrency || 'AUD';
        this.formatter = null;
        try {
          this.formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.currency });
        } catch (e) { /* fall back to plain string */ }
        this.debounceTimer = null;
        this.abortController = null;
        this.selectedIndex = -1;
        if (!this.input || !this.results) return;

        this.input.addEventListener('input', this.onInput.bind(this));
        this.input.addEventListener('focus', this.onInput.bind(this));
        this.input.addEventListener('keydown', this.onKeydown.bind(this));

        // Rewrite the term on the way to /search too, so pressing Enter on
        // "I/N" lands on the results page that actually has results.
        const form = this.querySelector('form');
        if (form) {
          form.addEventListener('submit', () => {
            const normalised = window.ADSearch.normalise(this.input.value);
            if (normalised && normalised !== this.input.value.trim()) this.input.value = normalised;
          });
        }
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
        });
      }

      onInput() {
        const query = this.input.value.trim();
        clearTimeout(this.debounceTimer);
        if (query.length < 2) {
          this.close();
          return;
        }
        this.debounceTimer = setTimeout(() => this.search(query), 220);
      }

      onKeydown(event) {
        const links = this.results.querySelectorAll('.site-header__search-link');
        if (!links.length) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.selectedIndex = Math.min(this.selectedIndex + 1, links.length - 1);
          this.highlight(links);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.selectedIndex = Math.max(this.selectedIndex - 1, -1);
          this.highlight(links);
        } else if (event.key === 'Enter' && this.selectedIndex > -1) {
          event.preventDefault();
          links[this.selectedIndex].click();
        } else if (event.key === 'Escape') {
          this.close();
        }
      }

      highlight(links) {
        this.results.querySelectorAll('.site-header__search-item').forEach((item, i) => {
          item.classList.toggle('is-selected', i === this.selectedIndex);
        });
        if (this.selectedIndex > -1) links[this.selectedIndex].scrollIntoView({ block: 'nearest' });
      }

      search(query) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        // "I/N" with nothing after it is a label, not a search term. Ask for
        // the number rather than returning whatever loosely matches "I" or "N".
        if (window.ADSearch.isLabelOnly(query)) {
          this.results.innerHTML =
            '<p class="site-header__search-empty">Enter the item number after &ldquo;' +
            this.escape(query.trim()) + '&rdquo; &mdash; for example ' +
            '<strong>' + this.escape(query.trim()) + ' 9362617004651</strong>.</p>';
          this.open();
          return;
        }

        const variants = window.ADSearch.candidates(query);

        // Walk the rewrites in order and show the first one that finds
        // something. A query that already works costs one request; only a
        // dead-end query pays for the extra round trips.
        const attempt = (index) => {
          if (index >= variants.length) {
            this.render({ products: [], collections: [], queries: [] }, query, query);
            return;
          }
          const term = variants[index];
          this.fetchSuggestions(term, signal)
            .then((results) => {
              const empty = !results.products.length && !results.collections.length && !results.queries.length;
              if (empty) {
                attempt(index + 1);
                return;
              }
              this.render(results, query, term);
            })
            .catch((error) => {
              if (error.name !== 'AbortError') this.close();
            });
        };

        attempt(0);
      }

      fetchSuggestions(term, signal) {
        const params = new URLSearchParams();
        params.set('q', term);
        params.set('resources[type]', 'product,collection,query');
        params.set('resources[limit]', '6');
        params.set('resources[options][unavailable_products]', 'last');
        // Measured 2026-09-09: Shopify currently IGNORES this parameter on this
        // shop — "AD-SBA029" scoped to fields=title still matches on SKU, and a
        // barcode matches although variants.barcode is not listed. It is kept
        // because the list is the one we want if Shopify ever honours it again,
        // and `tag` in particular is what makes the I/N searchable. Do not add
        // fields expecting a behaviour change, and do not drop `tag`.
        params.set(
          'resources[options][fields]',
          'title,product_type,variants.title,variants.sku,vendor,tag'
        );

        return fetch('/search/suggest.json?' + params.toString(), { signal })
          .then((response) => response.json())
          .then((data) => {
            const results = (data.resources && data.resources.results) || {};
            return {
              products: results.products || [],
              collections: results.collections || [],
              queries: results.queries || []
            };
          });
      }

      money(value) {
        const amount = parseFloat(value);
        if (isNaN(amount)) return '';
        if (this.formatter) return this.formatter.format(amount);
        return '$' + amount.toFixed(2);
      }

      render(results, query, matchedTerm) {
        this.selectedIndex = -1;
        // What the customer typed is what we echo back; what actually matched
        // is what the links have to carry.
        const searchTerm = matchedTerm || query;
        const products = results.products || [];
        const collections = (results.collections || []).slice(0, 4);
        const queries = (results.queries || []).slice(0, 4);

        if (!products.length && !collections.length && !queries.length) {
          this.results.innerHTML =
            '<p class="site-header__search-empty">No results found for &ldquo;' + this.escape(query) + '&rdquo;</p>' +
            '<a class="site-header__search-viewall" href="/collections/all">Browse all products &rarr;</a>';
          this.open();
          return;
        }

        const html = [];

        // Suggested searches (queries) — leading, compact
        if (queries.length) {
          const rows = queries.map((q) =>
            '<li class="site-header__search-item" role="option">' +
              '<a class="site-header__search-link site-header__search-link--term" href="' + q.url + '">' +
                '<svg class="site-header__search-term-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>' +
                '<span class="site-header__search-term-text">' + this.styled(q) + '</span>' +
              '</a>' +
            '</li>'
          ).join('');
          html.push('<p class="site-header__search-heading">Suggestions</p><ul class="site-header__search-list">' + rows + '</ul>');
        }

        // Products — image, title, price
        if (products.length) {
          const rows = products.map((product) => {
            const onSale = parseFloat(product.compare_at_price_min) > parseFloat(product.price_min);
            const image = product.image
              ? '<img class="site-header__search-thumb" src="' + product.image + '" alt="" width="56" height="56" loading="lazy">'
              : '<span class="site-header__search-thumb" aria-hidden="true"></span>';
            const compare = onSale
              ? '<s class="site-header__search-price-compare">' + this.money(product.compare_at_price_min) + '</s>'
              : '';
            return '' +
              '<li class="site-header__search-item" role="option">' +
                '<a class="site-header__search-link" href="' + product.url + '">' +
                  image +
                  '<span class="site-header__search-info">' +
                    '<span class="site-header__search-title">' + this.escape(product.title) + '</span>' +
                    '<span class="site-header__search-price">' +
                      '<span class="site-header__search-price-current">' + this.money(product.price_min) + '</span>' +
                      compare +
                    '</span>' +
                  '</span>' +
                '</a>' +
              '</li>';
          }).join('');
          html.push('<p class="site-header__search-heading">Products</p><ul class="site-header__search-list">' + rows + '</ul>');
        }

        // Collections — text links
        if (collections.length) {
          const rows = collections.map((collection) =>
            '<li class="site-header__search-item" role="option">' +
              '<a class="site-header__search-link site-header__search-link--term" href="' + collection.url + '">' +
                '<svg class="site-header__search-term-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/></svg>' +
                '<span class="site-header__search-term-text">' + this.escape(collection.title) + '</span>' +
              '</a>' +
            '</li>'
          ).join('');
          html.push('<p class="site-header__search-heading">Collections</p><ul class="site-header__search-list">' + rows + '</ul>');
        }

        const viewAllUrl = this.searchUrl + '?q=' + encodeURIComponent(searchTerm) + '&type=product';
        html.push('<a class="site-header__search-viewall" href="' + viewAllUrl + '">Search for &ldquo;' + this.escape(query) + '&rdquo; &rarr;</a>');

        this.results.innerHTML = html.join('');
        this.open();
      }

      // Shopify's styled_text only wraps the matched span in <mark>/<span>; the
      // user-typed portion is already HTML-escaped by Shopify. Fall back to a
      // safe escaped text when absent.
      styled(queryObj) {
        if (queryObj.styled_text) return queryObj.styled_text;
        return this.escape(queryObj.text);
      }

      escape(value) {
        const div = document.createElement('div');
        div.textContent = value == null ? '' : value;
        return div.innerHTML;
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.results.hidden = true;
        this.selectedIndex = -1;
        this.input.setAttribute('aria-expanded', 'false');
      }
    }
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;

        const prev = this.querySelector('[data-hero-prev]');
        const next = this.querySelector('[data-hero-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
        if (next) next.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.heroDot, 10))));

        if (this.dataset.autoplay === 'true') {
          const interval = parseInt(this.dataset.interval, 10) || 6000;
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start(interval));
          this.start(interval);
        }
      }

      go(target) {
        const count = this.slides.length;
        this.index = ((target % count) + count) % count;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      }

      start(interval) {
        this.stop();
        this.timer = window.setInterval(() => this.go(this.index + 1), interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }
    }
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v4"]) return;
  try {
    
  if (!customElements.get('product-info')) {
    class ProductInfo extends HTMLElement {
      connectedCallback() {
        this.dropBlankListItems();
        try {
          this.variants = JSON.parse(this.querySelector('[data-product-json]').textContent);
        } catch (e) {
          this.variants = [];
        }
        try {
          this.variantMedia = JSON.parse(this.querySelector('[data-variant-media-json]').textContent);
        } catch (e) {
          this.variantMedia = {};
        }
        try {
          const shippingVariants = JSON.parse(this.querySelector('[data-shipping-variants-json]').textContent);
          this.shippingVariants = new Map((shippingVariants || []).map((variant) => [String(variant.id), variant]));
        } catch (e) {
          this.shippingVariants = new Map();
        }
        this.shippingLocations = [
          ['melbourne', '3000', 'VIC'], ['dandenong south', '3175', 'VIC'], ['dandenong', '3175', 'VIC'], ['springvale', '3171', 'VIC'],
          ['noble park', '3174', 'VIC'], ['clayton', '3168', 'VIC'], ['mulgrave', '3170', 'VIC'], ['keysborough', '3173', 'VIC'],
          ['hallam', '3803', 'VIC'], ['cranbourne', '3977', 'VIC'], ['frankston', '3199', 'VIC'], ['moorabbin', '3189', 'VIC'],
          ['cheltenham', '3192', 'VIC'], ['richmond', '3121', 'VIC'], ['south yarra', '3141', 'VIC'], ['docklands', '3008', 'VIC'],
          ['footscray', '3011', 'VIC'], ['sunshine', '3020', 'VIC'], ['preston', '3072', 'VIC'], ['coburg', '3058', 'VIC'],
          ['sydney', '2000', 'NSW'], ['parramatta', '2150', 'NSW'], ['liverpool', '2170', 'NSW'], ['brisbane', '4000', 'QLD'],
          ['gold coast', '4217', 'QLD'], ['adelaide', '5000', 'SA'], ['perth', '6000', 'WA'], ['hobart', '7000', 'TAS'],
          ['canberra', '2601', 'ACT'], ['darwin', '0800', 'NT']
        ];
        this.shippingLocationAbort = null;

        this.moneyFormatter = new Intl.NumberFormat(this.dataset.locale || 'en', {
          style: 'currency',
          currency: this.dataset.currency || 'AUD'
        });

        this.querySelectorAll('[data-option-index]').forEach((select) => {
          select.addEventListener('change', () => this.onOptionChange());
        });

        this.querySelectorAll('[data-qty-change]').forEach((button) => {
          button.addEventListener('click', () => {
            const input = this.querySelector('input[name="quantity"]');
            if (!input) return;
            const next = (parseInt(input.value, 10) || 1) + parseInt(button.dataset.qtyChange, 10);
            input.value = Math.max(1, next);
          });
        });

        this.querySelectorAll('[data-thumb-position]').forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.thumbPosition));
        });

        this.querySelectorAll('[data-fulfillment-button]').forEach((button) => {
          button.addEventListener('click', () => this.setFulfillment(button.dataset.fulfillmentButton));
        });

        this.querySelectorAll('[data-share-product]').forEach((button) => {
          button.addEventListener('click', () => this.shareProduct(button));
        });

        const shippingForm = this.querySelector('[data-shipping-calc]');
        if (shippingForm) {
          shippingForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.calculateShipping();
          });
        }
        const shippingInput = this.querySelector('[data-shipping-postcode]');
        if (shippingInput) {
          shippingInput.addEventListener('input', () => {
            this.updateShippingSuggestions();
            this.fitShippingInputText();
          });
          shippingInput.addEventListener('focus', () => this.updateShippingSuggestions());
          shippingInput.addEventListener('blur', () => {
            window.setTimeout(() => this.hideShippingSuggestions(), 120);
          });
          this.initShippingInputAutofit(shippingInput);
        }

        this.initStickyBuyBar();
        this.initGallerySwipe();
      }

      /* Touch-swipe gallery (≤1119px). The swipe itself is the CSS scroll-snap
         strip above — this only keeps the dots/thumbs in sync with wherever the
         scroll lands, and scrolls the strip when a dot, thumb or variant change
         picks an image. With JS off the strip still scrolls by hand. */
      initGallerySwipe() {
        this.mediaList = this.querySelector('.product__media-list');
        if (!this.mediaList) return;

        this.mediaSlides = Array.from(this.mediaList.querySelectorAll('[data-media-position]'));
        if (this.mediaSlides.length < 2) return;

        const active = this.mediaSlides.find((slide) => slide.classList.contains('is-active'));
        this.activeMediaPosition = active ? active.dataset.mediaPosition : this.mediaSlides[0].dataset.mediaPosition;

        this.swipeQuery = window.matchMedia('(max-width: 1119px)');
        this.pendingGalleryScroll = null;

        let frame = null;
        this.mediaList.addEventListener('scroll', () => {
          if (frame || !this.isSwipeGallery()) return;
          frame = window.requestAnimationFrame(() => {
            frame = null;
            // A scroll this code started is in flight: every slide it passes
            // would otherwise light up its dot in turn. Wait for it to land.
            if (this.pendingGalleryScroll !== null) {
              if (Math.abs(this.mediaList.scrollLeft - this.pendingGalleryScroll) < 4) {
                this.pendingGalleryScroll = null;
              }
              return;
            }
            const slide = this.slideNearestToScroll();
            if (slide) this.markActiveMedia(slide.dataset.mediaPosition);
          });
        }, { passive: true });

        // A finger on the strip always wins over an animation still running.
        ['pointerdown', 'touchstart', 'wheel'].forEach((type) => {
          this.mediaList.addEventListener(type, () => { this.pendingGalleryScroll = null; }, { passive: true });
        });

        // Any width change moves the snap points: crossing the breakpoint
        // leaves the strip parked on whatever the other layout had selected,
        // and a rotation within it leaves the active slide half off-screen.
        const realign = () => this.scrollToActiveMedia(false);
        if (this.swipeQuery.addEventListener) {
          this.swipeQuery.addEventListener('change', realign);
        } else if (this.swipeQuery.addListener) {
          this.swipeQuery.addListener(realign);
        }
        window.addEventListener('resize', () => {
          window.clearTimeout(this.galleryResizeTimer);
          this.galleryResizeTimer = window.setTimeout(realign, 150);
        });
        realign();
      }

      isSwipeGallery() {
        return !!(this.swipeQuery && this.swipeQuery.matches && this.mediaSlides && this.mediaSlides.length > 1);
      }

      // Siblings share an offsetParent, so the difference is a valid scrollLeft
      // regardless of which ancestor that turns out to be.
      galleryOffset(slide) {
        return slide.offsetLeft - this.mediaSlides[0].offsetLeft;
      }

      slideNearestToScroll() {
        const left = this.mediaList.scrollLeft;
        let nearest = null;
        let nearestDistance = Infinity;
        this.mediaSlides.forEach((slide) => {
          const distance = Math.abs(this.galleryOffset(slide) - left);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearest = slide;
          }
        });
        return nearest;
      }

      scrollToActiveMedia(smooth) {
        if (!this.isSwipeGallery()) return;
        const slide = this.mediaSlides.find((item) => item.classList.contains('is-active'));
        if (!slide) return;

        const left = this.galleryOffset(slide);
        if (Math.abs(this.mediaList.scrollLeft - left) < 2) return;

        this.pendingGalleryScroll = left;
        this.mediaList.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });

        // Safety net: a scroll that never reaches its target (interrupted,
        // element resized mid-flight) must not wedge the sync off for good.
        window.clearTimeout(this.galleryScrollTimer);
        this.galleryScrollTimer = window.setTimeout(() => {
          this.pendingGalleryScroll = null;
        }, 1500);
      }

      selectedOptions() {
        return Array.from(this.querySelectorAll('[data-option-index]'))
          .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
          .map((select) => select.value);
      }

      findVariant() {
        const options = this.selectedOptions();
        if (!options.length) return this.variants[0] || null;
        return this.variants.find((variant) =>
          options.every((value, index) => variant.options[index] === value)
        ) || null;
      }

      onOptionChange() {
        this.querySelectorAll('[data-option-index]').forEach((select) => {
          const label = this.querySelector('[data-option-value="' + select.dataset.optionIndex + '"]');
          if (label) label.textContent = select.value;
        });

        const variant = this.findVariant();
        this.updateButton(variant);
        this.updatePrice(variant);
        this.updateMeta(variant);
        this.updateStickyPrice(variant);
        if (!variant) return;

        const idInput = this.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;

        const mediaPosition = this.variantMedia[String(variant.id)];
        if (mediaPosition) this.setActiveMedia(mediaPosition);

        if (this.dataset.url && window.history.replaceState) {
          window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
        }
      }

      updateButton(variant) {
        const buttons = this.querySelectorAll('[data-add-button]');
        const labels = this.querySelectorAll('[data-add-button-text]');
        if (!buttons.length || !labels.length) return;

        let text = this.dataset.textAdd;
        let disabled = false;
        if (!variant) {
          disabled = true;
          text = this.dataset.textUnavailable;
        } else if (!variant.available) {
          disabled = true;
          text = this.dataset.textSoldOut;
        }

        buttons.forEach((button) => { button.disabled = disabled; });
        labels.forEach((label) => { label.textContent = text; });
      }

      updatePrice(variant) {
        const price = this.querySelector('[data-price]');
        const compare = this.querySelector('[data-compare-price]');
        const badge = this.querySelector('[data-save-badge]');
        const saveSummary = this.querySelector('[data-save-summary]');
        const afterpay = this.querySelector('[data-afterpay]');
        if (!price || !variant) return;

        price.textContent = this.moneyFormatter.format(variant.price / 100);
        if (afterpay) afterpay.textContent = this.moneyFormatter.format(variant.price / 400);

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compare) {
          compare.classList.toggle('price__hidden', !onSale);
          compare.textContent = onSale ? this.moneyFormatter.format(variant.compare_at_price / 100) : '';
        }
        if (badge) {
          badge.classList.toggle('price__hidden', !onSale);
          if (onSale) {
            const saved = this.moneyFormatter.format((variant.compare_at_price - variant.price) / 100);
            badge.textContent = (this.dataset.textSave || 'Save __AMOUNT__').replace('__AMOUNT__', saved);
          }
        }
        if (saveSummary) {
          saveSummary.hidden = !onSale;
          if (onSale) {
            const savedAmount = (variant.compare_at_price - variant.price) / 100;
            const percent = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            saveSummary.textContent = 'Save ' + this.moneyFormatter.format(savedAmount) + ' · ' + percent + '% off';
          }
        }
      }

      updateStickyPrice(variant) {
        const price = this.querySelector('[data-sticky-price]');
        const compare = this.querySelector('[data-sticky-compare]');
        if (!price || !variant) return;
        price.textContent = this.moneyFormatter.format(variant.price / 100);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compare) {
          compare.classList.toggle('price__hidden', !onSale);
          compare.textContent = onSale ? this.moneyFormatter.format(variant.compare_at_price / 100) : '';
        }
      }

      updateMeta(variant) {
        // The SKU-rewriting loop that used to live here is gone. It targeted
        // [data-sku]/[data-item-number], and the only element inside
        // <product-info> still carrying data-sku is REVIEWS.io's rating widget
        // (.ruk_rating_snippet, where data-sku is its lookup key, not a text
        // placeholder) — so on a variant change it replaced the rendered
        // "★★★★☆ (2 Reviews)" with the raw SKU string. The visible identifiers
        // is now I/N, a product-level value, so nothing here needs updating per
        // variant.
        this.querySelectorAll('[data-stock-label]').forEach((stockLabel) => {
          const available = !!(variant && variant.available);
          stockLabel.textContent = available ? this.dataset.textInStock : this.dataset.textOutOfStock;
        });
      }

      setActiveMedia(position) {
        this.markActiveMedia(position);
        this.scrollToActiveMedia(true);
      }

      // Highlight only — used both by an explicit pick and by the swipe
      // handler, which must not scroll the strip it is being driven by.
      markActiveMedia(position) {
        if (this.activeMediaPosition === String(position)) return;
        this.activeMediaPosition = String(position);

        this.querySelectorAll('[data-media-position]').forEach((media) => {
          media.classList.toggle('is-active', media.dataset.mediaPosition === String(position));
        });
        this.querySelectorAll('[data-thumb-position]').forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.thumbPosition === String(position));
        });
      }

      setFulfillment(method) {
        this.querySelectorAll('[data-fulfillment-button]').forEach((button) => {
          const active = button.dataset.fulfillmentButton === method;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.querySelectorAll('[data-fulfillment-panel]').forEach((panel) => {
          const active = panel.dataset.fulfillmentPanel === method;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }

      async shareProduct(button) {
        const title = this.dataset.productTitle || document.title;
        const url = window.location.href;

        if (navigator.share) {
          try {
            await navigator.share({ title, url });
            return;
          } catch (error) {
            // AbortError means the user dismissed the sheet — that is a
            // decision, not a failure. Anything else means the sheet never
            // opened, so fall through to copying instead of going quiet.
            if (error && error.name === 'AbortError') return;
          }
        }

        this.copyShareLink(button, url);
      }

      async copyShareLink(button, url) {
        let copied = false;

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            copied = true;
          }
        } catch (error) {
          copied = false;
        }

        // The Clipboard API needs a secure context AND a focused document, and
        // it rejects without either. The old selection trick still works in
        // several of the cases where it does not.
        if (!copied) copied = this.copyWithSelection(url);

        this.flashShareState(button, copied);
      }

      copyWithSelection(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0;';
        document.body.appendChild(field);

        let copied = false;
        try {
          field.select();
          field.setSelectionRange(0, text.length);
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }

        field.remove();
        return copied;
      }

      flashShareState(button, copied) {
        const flash = button.querySelector('[data-share-flash]');
        const message = copied
          ? (button.dataset.shareCopied || 'Link copied')
          : (button.dataset.shareFailed || 'Copy failed');

        // Text stays put after the bubble fades: role="status" announces on
        // change, and clearing it would blank the label mid-fade.
        if (flash) flash.textContent = message;
        button.classList.remove('is-copied', 'is-failed');
        button.classList.add(copied ? 'is-copied' : 'is-failed');
        button.setAttribute('title', message);

        window.clearTimeout(this.shareFlashTimer);
        this.shareFlashTimer = window.setTimeout(() => {
          button.classList.remove('is-copied', 'is-failed');
          // Back to the resting label — the old code left the tooltip claiming
          // a copy that had happened minutes earlier.
          button.setAttribute('title', button.dataset.shareLabel || 'Share product');
        }, 2200);
      }

      // Safety net for description HTML pasted out of Word or migrated from the
      // old platform, which arrives with whitespace-only <li> that render as
      // stray empty bullets. The catalogue was cleaned at the data level on
      // 2026-08-02 (35 products, 51 items) — this stops it coming back.
      //
      // CSS cannot do this: `li:empty` does not match an element containing a
      // newline, and these all contain "\n" (verified against a live product,
      // 0 matches out of 10 blank items).
      dropBlankListItems() {
        this.querySelectorAll('.rte li').forEach((li) => {
          // An <li> holding only an image has no text but is not empty.
          if (li.querySelector('img, a, iframe, svg, video, picture')) return;
          if (!li.textContent.replace(/ /g, '').trim()) li.remove();
        });
      }

      async calculateShipping() {
        const input = this.querySelector('[data-shipping-postcode]');
        const submit = this.querySelector('[data-shipping-submit]');
        const result = this.querySelector('[data-shipping-result]');
        if (!input || !result) return;

        const destination = this.resolveShippingDestination(input.value || '');
        const postcode = destination.postcode;
        if (!/^\d{4}$/.test(postcode)) {
          this.renderShippingResult(result, { error: 'Please enter a valid 4-digit Australian postcode, or select a suburb from the suggestions.' });
          return;
        }
        if (destination.label) {
          input.value = destination.label;
          this.fitShippingInputText();
        }

        const variantInput = this.querySelector('[data-variant-id]');
        const variantId = variantInput && variantInput.value;
        if (!variantId) {
          this.renderShippingResult(result, { error: 'Please select an available option first.' });
          return;
        }

        const originalLabel = submit ? submit.textContent : '';
        if (submit) { submit.disabled = true; submit.textContent = 'Checking…'; }
        result.hidden = false;
        result.className = 'product__shipping-result';
        result.textContent = 'Getting delivery rates…';

        const apiBase = (this.dataset.shippingApiBase || '').trim().replace(/\/$/, '');
        if (apiBase) {
          try {
            const rates = await this.fetchShippingRatesFromApp(apiBase, postcode);
            this.renderShippingResult(result, { rates });
          } catch (err) {
            this.renderShippingResult(result, { error: 'Could not retrieve delivery rates. Please try again, or enter your address at checkout.' });
          } finally {
            if (submit) { submit.disabled = false; submit.textContent = originalLabel || 'Check'; }
          }
          return;
        }

        const province = this.provinceForPostcode(postcode);
        let addedTempItem = false;
        let qtyBefore = 0;

        try {
          // Snapshot the current quantity of this variant so we can restore it afterwards.
          const cartBefore = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
          const existing = (cartBefore.items || []).find((item) => String(item.variant_id) === String(variantId));
          qtyBefore = existing ? existing.quantity : 0;

          // Temporarily add one of this item so the quote reflects this product.
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          addedTempItem = true;

          const rates = await this.fetchShippingRates(postcode, province);
          this.renderShippingResult(result, { rates });

          // Restore the cart to its original state for this variant.
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qtyBefore })
          });
          addedTempItem = false;
        } catch (err) {
          if (addedTempItem) {
            try {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: qtyBefore })
              });
            } catch (e) {}
          }
          this.renderShippingResult(result, { error: 'Could not retrieve delivery rates. Please try again, or enter your address at checkout.' });
        } finally {
          if (submit) { submit.disabled = false; submit.textContent = originalLabel || 'Check'; }
        }
      }

      /* The delivery card is narrow, and how narrow depends on the breakpoint and
         on the column it lands in — so "Postcode or suburb" (and long suburb
         labels like "Sunshine Beach QLD 4567") clipped mid-word. Shrink the type
         only as far as it has to go to fit, and let it grow back when there is
         room again. */
      initShippingInputAutofit(input) {
        this.fitShippingInputText();

        // Fires for breakpoint reflows and for the card going from hidden (zero
        // width, unmeasurable) to visible when its fulfillment tab is opened.
        if (window.ResizeObserver) {
          let frame = null;
          const observer = new ResizeObserver(() => {
            if (frame) return;
            frame = window.requestAnimationFrame(() => {
              frame = null;
              this.fitShippingInputText();
            });
          });
          observer.observe(input);
        } else {
          window.addEventListener('resize', () => this.fitShippingInputText());
        }

        // A first measurement taken against the fallback font is the wrong width.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.fitShippingInputText());
        }
      }

      fitShippingInputText() {
        const input = this.querySelector('[data-shipping-postcode]');
        if (!input) return;

        if (!this.shippingPlaceholders) {
          // Shorter stand-ins for a field too narrow to hold the full prompt even
          // at the minimum size. The aria-label keeps the full wording either way.
          this.shippingPlaceholders = [input.getAttribute('placeholder') || 'Postcode or suburb', 'Postcode/suburb', 'Postcode'];
        }

        // Measure at the stylesheet's own size, not at whatever this method last
        // set, so a return to a wider layout can undo an earlier shrink.
        input.style.fontSize = '';

        const styles = window.getComputedStyle(input);
        const baseSize = parseFloat(styles.fontSize);
        const available = input.clientWidth
          - parseFloat(styles.paddingLeft || 0)
          - parseFloat(styles.paddingRight || 0)
          - 2; // caret + sub-pixel rounding
        if (!baseSize || !(available > 0)) return;

        const widthAt = (text, size) => this.measureTextWidth(text, size, styles);
        // Advances scale with font-size, so one ratio lands within a rounding
        // error of the answer — then re-measure and nudge down until it truly fits.
        const sizeFor = (text, floor) => {
          let size = baseSize;
          for (let pass = 0; pass < 6; pass++) {
            const width = widthAt(text, size);
            if (!width) return baseSize;
            if (width <= available) return size;
            const next = Math.floor((available / width) * size * 10) / 10;
            size = Math.max(floor, Math.min(next, size - 0.1));
            if (size === floor) break;
          }
          return size;
        };
        const apply = (size) => { input.style.fontSize = size < baseSize ? size + 'px' : ''; };

        const MIN_SIZE = 10;
        if (input.value) {
          apply(sizeFor(input.value, MIN_SIZE));
          return;
        }

        // Shrinking keeps the wording the copy asked for, so only fall back to a
        // shorter prompt once the minimum size still cannot fit it.
        let text = this.shippingPlaceholders[0];
        let size = sizeFor(text, MIN_SIZE);
        for (let i = 1; i < this.shippingPlaceholders.length; i++) {
          if (widthAt(text, size) <= available) break;
          text = this.shippingPlaceholders[i];
          size = sizeFor(text, MIN_SIZE);
        }
        if (input.getAttribute('placeholder') !== text) input.setAttribute('placeholder', text);
        apply(size);
      }

      /* Measured with a real span rather than canvas measureText so the number is
         the one the layout will use — letter/word spacing and text-transform are
         copied across, and canvas silently ignores all three. */
      measureTextWidth(text, size, styles) {
        if (!this.textRuler) {
          this.textRuler = document.createElement('span');
          this.textRuler.setAttribute('aria-hidden', 'true');
          this.textRuler.style.cssText = 'position:absolute;top:0;left:-9999px;visibility:hidden;white-space:pre;pointer-events:none';
          document.body.appendChild(this.textRuler);
        }
        const ruler = this.textRuler;
        ruler.style.font = styles.fontStyle + ' ' + styles.fontWeight + ' ' + size + 'px ' + styles.fontFamily;
        ruler.style.letterSpacing = styles.letterSpacing;
        ruler.style.wordSpacing = styles.wordSpacing;
        ruler.style.textTransform = styles.textTransform;
        ruler.style.fontFeatureSettings = styles.fontFeatureSettings;
        ruler.textContent = text;
        return ruler.getBoundingClientRect().width;
      }

      resolveShippingDestination(value) {
        const raw = String(value || '').trim();
        const postcodeMatch = raw.match(/\b(\d{4})\b/);
        if (postcodeMatch) return { postcode: postcodeMatch[1], label: raw };

        const normalized = raw.toLowerCase().replace(/\b(vic|nsw|qld|sa|wa|tas|act|nt)\b/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
        const exact = (this.shippingLocations || []).find((item) => item[0] === normalized);
        if (exact) return { postcode: exact[1], label: this.shippingLocationLabel(exact) };

        const startsWith = (this.shippingLocations || []).filter((item) => item[0].startsWith(normalized));
        if (normalized && startsWith.length === 1) {
          return { postcode: startsWith[0][1], label: this.shippingLocationLabel(startsWith[0]) };
        }

        return { postcode: '', label: raw };
      }

      updateShippingSuggestions() {
        const input = this.querySelector('[data-shipping-postcode]');
        const suggestions = this.querySelector('[data-shipping-suggestions]');
        if (!input || !suggestions) return;

        const raw = String(input.value || '').trim();
        const normalized = raw.toLowerCase().replace(/\b(vic|nsw|qld|sa|wa|tas|act|nt)\b/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
        const isPostcodeQuery = /^\d{2,4}$/.test(normalized);
        if ((!/[a-z]/.test(normalized) || normalized.length < 2) && !isPostcodeQuery) {
          suggestions.hidden = true;
          suggestions.innerHTML = '';
          return;
        }

        const requestedValue = raw;
        this.fetchShippingLocationSuggestions(normalized).then((matches) => {
          if (input.value !== requestedValue) return;
          this.renderShippingSuggestions(matches, suggestions);
        });
      }

      async fetchShippingLocationSuggestions(query) {
        const url = (this.dataset.shippingLocationsUrl || '').trim();
        if (!url) return this.fallbackShippingLocationSuggestions(query);

        if (this.shippingLocationAbort) this.shippingLocationAbort.abort();
        this.shippingLocationAbort = new AbortController();

        try {
          const params = new URLSearchParams({ q: query, limit: /^\d{4}$/.test(query) ? '60' : '8' });
          const response = await fetch(url + '?' + params.toString(), {
            headers: { 'Accept': 'application/json' },
            signal: this.shippingLocationAbort.signal
          });
          const payload = await response.json().catch(() => null);
          const locations = Array.isArray(payload?.results) ? payload.results : payload?.locations;
          if (!response.ok || !payload?.ok || !Array.isArray(locations)) return [];
          return locations.map((item) => [
            String(item.suburb || '').toLowerCase(),
            String(item.postcode || ''),
            String(item.state || '').toUpperCase(),
            String(item.displayLabel || item.label || '')
          ]);
        } catch (error) {
          if (error?.name === 'AbortError') return [];
          return this.fallbackShippingLocationSuggestions(query);
        }
      }

      fallbackShippingLocationSuggestions(query) {
        const startsWith = [];
        const contains = [];
        (this.shippingLocations || []).forEach((item) => {
          const postcode = String(item[1] || '');
          if (postcode.startsWith(query)) startsWith.push(item);
          else if (item[0].startsWith(query)) startsWith.push(item);
          else if (item[0].includes(query)) contains.push(item);
        });
        return startsWith.concat(contains).slice(0, 6);
      }

      renderShippingSuggestions(matches, suggestions) {
        const input = this.querySelector('[data-shipping-postcode]');
        if (!input) return;

        if (!matches.length) {
          suggestions.hidden = true;
          suggestions.innerHTML = '';
          return;
        }

        const many = matches.length > 8;
        suggestions.classList.toggle('is-compact', many);
        const header = many
          ? '<div class="product__postcode-suggestions-head">' + this.escapeHtml(matches[0][2] + ' ' + matches[0][1]) + ' · ' + matches.length + ' suburbs — pick yours</div>'
          : '';
        suggestions.innerHTML = header + matches.map((item) => {
          const suburb = this.titleCase(item[0]);
          const label = item[3] || this.shippingLocationLabel(item);
          return '<button class="product__postcode-suggestion" type="button" data-shipping-suggestion-value="' + this.escapeHtml(label) + '">' +
            '<span class="product__postcode-suggestion-main"><span class="product__postcode-suggestion-suburb">' + this.escapeHtml(suburb) + '</span>' + (many ? '' : '<span class="product__postcode-suggestion-meta">Select suburb for delivery quote</span>') + '</span>' +
            '<span class="product__postcode-suggestion-code">' + this.escapeHtml(item[2] + ' ' + item[1]) + '</span></button>';
        }).join('');
        suggestions.hidden = false;

        // On narrow screens the right-anchored panel can spill past the viewport edge; nudge it back in.
        suggestions.style.transform = '';
        const panel = suggestions.getBoundingClientRect();
        const edge = 8;
        const shift = panel.left < edge ? edge - panel.left : (panel.right > window.innerWidth - edge ? window.innerWidth - edge - panel.right : 0);
        if (shift) suggestions.style.transform = 'translateX(' + Math.round(shift) + 'px)';

        suggestions.querySelectorAll('[data-shipping-suggestion-value]').forEach((button) => {
          button.addEventListener('mousedown', (event) => event.preventDefault());
          button.addEventListener('click', () => {
            input.value = button.dataset.shippingSuggestionValue || '';
            this.fitShippingInputText();
            this.hideShippingSuggestions();
            input.focus();
          });
        });
      }

      shippingLocationLabel(item) {
        return this.titleCase(item[0]) + ' ' + (item[2] ? item[2] + ' ' : '') + item[1];
      }

      hideShippingSuggestions() {
        const suggestions = this.querySelector('[data-shipping-suggestions]');
        if (!suggestions) return;
        suggestions.hidden = true;
        suggestions.innerHTML = '';
      }

      titleCase(value) {
        return String(value || '').replace(/\b\w/g, (char) => char.toUpperCase());
      }

      currentShippingItem() {
        const variantId = this.querySelector('[data-variant-id]')?.value;
        if (!variantId) return null;

        const quantity = Math.max(1, parseInt(this.querySelector('input[name="quantity"]')?.value || '1', 10) || 1);
        const shippingVariant = this.shippingVariants instanceof Map ? this.shippingVariants.get(String(variantId)) : null;
        const variant = (this.variants || []).find((item) => String(item.id) === String(variantId));

        return {
          quantity,
          actualWeightKg: Number(shippingVariant?.weightGrams ?? variant?.weight ?? 0) / 1000,
          lengthCm: Number(shippingVariant?.lengthCm || 0),
          widthCm: Number(shippingVariant?.widthCm || 0),
          heightCm: Number(shippingVariant?.heightCm || 0),
          shippingQty: Number(shippingVariant?.shippingQty || 1),
          packageQty: Number(shippingVariant?.packageQty || 0)
        };
      }

      async fetchShippingRatesFromApp(apiBase, postcode) {
        const item = this.currentShippingItem();
        if (!item) throw new Error('MISSING_VARIANT');

        const response = await fetch(apiBase + '/api/shipping/quote2', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            destinationPostcode: postcode,
            items: [item]
          })
        });

        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload?.ok) {
          throw new Error(payload?.code || payload?.message || 'QUOTE_FAILED');
        }

        const rates = [];
        if (payload.standard) {
          rates.push({
            ...payload.standard,
            uiName: 'Standard delivery',
            uiMeta: ''
          });
        }
        if (payload.localDelivery) {
          rates.push({
            ...payload.localDelivery,
            uiName: 'Local delivery',
            uiMeta: ''
          });
        }
        return rates;
      }

      async fetchShippingRates(postcode, province) {
        const params = new URLSearchParams();
        params.set('shipping_address[zip]', postcode);
        params.set('shipping_address[country]', 'Australia');
        if (province) params.set('shipping_address[province]', province);

        // Kick off async rate preparation, then poll until Shopify returns them.
        await fetch('/cart/prepare_shipping_rates.json?' + params.toString(), {
          method: 'POST', headers: { 'Accept': 'application/json' }
        });
        for (let attempt = 0; attempt < 10; attempt += 1) {
          const data = await fetch('/cart/async_shipping_rates.json', {
            headers: { 'Accept': 'application/json' }
          }).then((r) => r.json());
          if (Array.isArray(data.shipping_rates)) return data.shipping_rates;
          await new Promise((resolve) => setTimeout(resolve, 600));
        }
        // Fallback to the synchronous endpoint if polling timed out.
        const sync = await fetch('/cart/shipping_rates.json?' + params.toString(), {
          headers: { 'Accept': 'application/json' }
        }).then((r) => r.json());
        return Array.isArray(sync.shipping_rates) ? sync.shipping_rates : [];
      }

      renderShippingResult(result, { rates, error }) {
        result.hidden = false;
        if (error) {
          result.className = 'product__shipping-result product__shipping-result--error';
          result.textContent = error;
          return;
        }
        if (!rates || !rates.length) {
          result.className = 'product__shipping-result product__shipping-result--error';
          result.textContent = 'No delivery options found for this postcode. Please contact us or choose Click & Collect.';
          return;
        }
        result.className = 'product__shipping-result';
        const items = rates.map((rate) => {
          const amount = parseFloat(rate.price);
          const isFree = !isNaN(amount) && amount === 0;
          const priceLabel = isFree ? 'FREE' : this.moneyFormatter.format(isNaN(amount) ? 0 : amount);
          const priceClass = 'product__shipping-rate-price' + (isFree ? ' product__shipping-result--free' : '');
          const name = rate.uiName || rate.presentment_name || rate.name || rate.serviceName || 'Delivery';
          const meta = rate.uiMeta || '';
          const nameHtml = '<span><span class="product__shipping-rate-name">' + this.escapeHtml(name) + '</span>' +
            (meta ? '<small class="product__shipping-rate-meta">' + this.escapeHtml(meta) + '</small>' : '') +
            '</span>';
          return '<li>' + nameHtml +
                  '<span class="' + priceClass + '">' + priceLabel + '</span></li>';
        }).join('');
        result.innerHTML = '<ul>' + items + '</ul>';
      }

      escapeHtml(str) {
        return String(str).replace(/[&<>"']/g, (c) =>
          ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      }

      provinceForPostcode(postcode) {
        const n = parseInt(postcode, 10);
        if (isNaN(n)) return '';
        if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
        if ((n >= 1000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
        if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
        if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
        if (n >= 5000 && n <= 5799) return 'SA';
        if (n >= 6000 && n <= 6797) return 'WA';
        if (n >= 7000 && n <= 7799) return 'TAS';
        if (n >= 800 && n <= 899) return 'NT';
        return '';
      }

      initStickyBuyBar() {
        const bar = this.querySelector('[data-sticky-buy-bar]');
        const sentinel = this.querySelector('[data-buy-sentinel]');
        const mainButton = this.querySelector('.product__purchase .product__add-button');
        if (!bar || !sentinel) return;

        const setVisible = (visible) => {
          if (visible) bar.removeAttribute('hidden');
          else bar.setAttribute('hidden', '');
        };

        const update = () => {
          const sectionRect = this.getBoundingClientRect();
          if (sectionRect.bottom <= window.innerHeight * .35) {
            setVisible(false);
            return;
          }

          const trigger = mainButton || sentinel;
          const rect = trigger.getBoundingClientRect();
          setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
        };

        if ('IntersectionObserver' in window && mainButton) {
          const observer = new IntersectionObserver((entries) => {
            const sectionRect = this.getBoundingClientRect();
            const shouldHideNearEnd = sectionRect.bottom <= window.innerHeight * .35;
            setVisible(!entries[0].isIntersecting && !shouldHideNearEnd);
          }, { root: null, threshold: 0, rootMargin: '0px 0px -20px 0px' });
          observer.observe(mainButton);
        }

        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }
    customElements.define('product-info', ProductInfo);
  }

  function bindAddOnCarousels(scope) {
    (scope || document).querySelectorAll('[data-ad-addons-carousel]').forEach((root) => {
      if (root.dataset.adAddonsBound === 'true') return;
      root.dataset.adAddonsBound = 'true';
      const viewport = root.querySelector('[data-ad-addons-viewport]');
      const progress = root.querySelector('[data-ad-addons-progress]');
      const prev = root.querySelector('[data-ad-addons-prev]');
      const next = root.querySelector('[data-ad-addons-next]');
      const updateProgress = () => {
        if (!viewport || !progress) return;
        const max = viewport.scrollWidth - viewport.clientWidth;
        const ratio = max > 0 ? viewport.scrollLeft / max : 0;
        progress.style.transform = `translateX(${ratio * 78}px)`;
      };
      const scrollByCard = (direction) => {
        const card = root.querySelector('.ad-addon-card');
        if (!viewport || !card) return;
        viewport.scrollBy({ left: direction * (card.offsetWidth + 14), behavior: 'smooth' });
      };
      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      viewport?.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();

      root.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-ad-addon-form]');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('[data-ad-addon-submit]');
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding...';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Add failed');
          button.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => { button.textContent = original; button.disabled = false; }, 1400);
        } catch (error) {
          button.textContent = 'Try again';
          setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
        }
      });
    });
  }
  bindAddOnCarousels(document);
  document.addEventListener('shopify:section:load', (event) => bindAddOnCarousels(event.target));

  /* ---- REVIEWS.io rating breakdown ---------------------------------------
     Fill in the bars REVIEWS.io leaves empty. The percentage is read back out
     of the row's own label ("15 . 63%") because that is the only place the
     widget puts it - nothing in its DOM differs from row to row otherwise.

     Everything here fails quiet: if the panel, the row shape or the label ever
     stop matching, no bar is drawn and the page is left exactly as REVIEWS.io
     rendered it, minus their inert bar. See the stylesheet for the evidence
     that this is their bug and not ours. */
  function adRatingBreakdown() {
    document.querySelectorAll('.SentimentWidget__breakdownContent .R-SliderIndicator').forEach(function (slider) {
      var slot = slider.closest('.u-flexGrow');
      var row = slot && slot.parentElement;
      var label = row && row.lastElementChild;
      var found = label && /(\d+(?:\.\d+)?)\s*%/.exec(label.textContent || '');
      if (!found) return;
      var bar = slot.querySelector('.ad-rating-bar');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ad-rating-bar';
        bar.appendChild(document.createElement('span'));
        slot.appendChild(bar);
      }
      var pct = Math.max(0, Math.min(100, parseFloat(found[1])));
      bar.firstChild.style.width = pct + '%';
    });
  }

  /* The widget mounts async and re-renders on sort, filter and paging, so watch
     it rather than running once. Only childList is observed: our own width
     updates are attribute writes, which therefore cannot re-trigger this. */
  (function adWatchRatingBreakdown(tries) {
    var host = document.getElementById('ReviewsWidget');
    if (!host) {
      if ((tries || 0) < 20) setTimeout(function () { adWatchRatingBreakdown((tries || 0) + 1); }, 500);
      return;
    }
    adRatingBreakdown();
    if (typeof MutationObserver !== 'function') return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(adRatingBreakdown, 120);
    }).observe(host, { childList: true, subtree: true });
  })(0);

  /* ---- Customer photos (UGC) -------------------------------------------
     Reads REVIEWS.io's public timeline API (same endpoint the Polaris review
     widget uses) and renders the photos as their own gallery, separate from
     the written reviews. Review text is user-generated, so every string is
     written with textContent — never innerHTML. */
  function adUgcMediaUrl(file, size) {
    return 'https://media.reviews.co.uk/resize/create?format=jpg&width=' + size + '&height=' + size +
      '&src=https://d1011j0lbv5k1u.cloudfront.net/assets/' + file;
  }

  // Video lives on a different CloudFront distribution than the stills, and the
  // stills host refuses direct reads. See the comment above the block markup.
  function adUgcVideoUrl(file) {
    return 'https://d19ayerf5ehaab.cloudfront.net/assets/' + file;
  }

  function adUgcEndpoint(store, skus, limit, want) {
    var url = 'https://api.reviews.io/timeline/data?type=product_review&widget=polaris&sort=date_desc&page=1';
    url += '&with=' + (want || 'media');
    url += '&store=' + encodeURIComponent(store);
    url += '&per_page=' + limit;
    if (skus) url += '&sku=' + encodeURIComponent(skus);
    return url;
  }

  // Reviews the shop has chosen not to show here, by REVIEWS.io review id
  // (section setting "Hidden review IDs"). Applied to the media, not the request,
  // so a hidden review never leaves a gap in a page that asked for a fixed count.
  function adUgcWithoutHidden(items, hideList) {
    var hidden = {};
    String(hideList || '').split(/[\s,;]+/).forEach(function (id) { if (id) hidden[id] = true; });
    if (!Object.keys(hidden).length) return items;
    return items.filter(function (item) { return !(item.reviewId && hidden[item.reviewId]); });
  }

  function adUgcDedupe(items) {
    var seen = {};
    return items.filter(function (item) {
      var key = item.type + ':' + (item.video || item.file);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function adUgcFetch(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('REVIEWS.io responded ' + response.status);
      return response.json();
    });
  }

  /**
   * Retired SKUs that point at one of this product's SKUs.
   *
   * REVIEWS.io files a review under whichever SKU was live when it was left and
   * offers no way to correct that afterwards, so the mapping is kept on our side
   * (Operation Hub -> Reviews -> UGC match) and published as a small JSON map of
   * old SKU -> current SKU. Failing to load it is not an error: the block simply
   * falls back to asking for this product's own SKUs.
   */
  function adUgcAliases(url, skus) {
    if (!url || !skus) return Promise.resolve('');
    return adUgcFetch(url).then(function (payload) {
      var want = {};
      skus.split(';').forEach(function (sku) { if (sku) want[sku] = true; });
      var map = (payload && payload.aliases) || {};
      var extra = Object.keys(map).filter(function (alias) { return want[map[alias]] && !want[alias]; });
      return extra.join(';');
    }).catch(function () { return ''; });
  }

  function adUgcCollect(payload) {
    var rows = (payload && payload.timeline) || [];
    var media = [];
    rows.forEach(function (row) {
      var review = row._source || {};
      var about = {
        author: (review.author || '').trim() || 'Verified customer',
        rating: Math.round(Number(review.rating) || 0),
        body: (review.comments || '').trim(),
        date: review.human_date || '',
        productName: review.product_name || '',
        productLink: review.product_link || ''
      };
      // Video first within a review: there is far less of it than photos, so it
      // would otherwise never make the first screen.
      (review.videos || []).forEach(function (video) {
        if (!video || !video.video_url || video.status === 'inactive') return;
        if (Number(video.processed) === 0) return;
        media.push(Object.assign({
          type: 'video',
          file: video.thumbnail_cropped || video.thumbnail,
          video: video.video_url,
          reviewId: String(video.product_review_id || review.product_review_id || review.id || '')
        }, about));
      });
      (review.images || []).forEach(function (image) {
        if (!image || !image.image || image.status === 'inactive') return;
        media.push(Object.assign({
          type: 'image',
          file: image.image,
          reviewId: String(image.product_review_id || review.product_review_id || review.id || '')
        }, about));
      });
    });
    return media;
  }

  function adUgcStars(rating) {
    var value = Math.max(0, Math.min(5, rating));
    return '★'.repeat(value) + '☆'.repeat(5 - value);
  }

  function setupAdUgc(root) {
    if (root.dataset.ugcReady === '1') return;
    root.dataset.ugcReady = '1';

    var store = root.dataset.ugcStore || '';
    if (!store || typeof fetch !== 'function') return;

    var designMode = root.dataset.ugcDesign === '1';
    var grid = root.querySelector('[data-ugc-grid]');
    var note = root.querySelector('[data-ugc-note]');
    var count = root.querySelector('[data-ugc-count]');
    var moreButton = root.querySelector('[data-ugc-more]');
    // The lightbox is the element rendered straight after the block. Scope the
    // lookup to that sibling so two blocks under one parent never share one.
    var lightbox = root.nextElementSibling;
    if (!lightbox || !lightbox.hasAttribute('data-ugc-lightbox')) lightbox = root.parentNode.querySelector('[data-ugc-lightbox]');
    if (!lightbox) return;
    var image = lightbox.querySelector('[data-ugc-image]');
    var video = lightbox.querySelector('[data-ugc-video]');
    var source = lightbox.querySelector('[data-ugc-source]');
    var stars = lightbox.querySelector('[data-ugc-stars]');
    var body = lightbox.querySelector('[data-ugc-body]');
    var author = lightbox.querySelector('[data-ugc-author]');
    var date = lightbox.querySelector('[data-ugc-date]');
    var productLink = lightbox.querySelector('[data-ugc-product]');
    var previous = lightbox.querySelector('[data-ugc-prev]');
    var next = lightbox.querySelector('[data-ugc-next]');

    var limit = parseInt(root.dataset.ugcLimit, 10) || 36;
    var pageSize = parseInt(root.dataset.ugcVisible, 10) || 12;
    var photos = [];
    var rendered = 0;
    var current = 0;
    var storeWide = false;
    var lastFocus = null;

    var skus = root.dataset.ugcSkus || '';
    // A product with no SKU at all cannot be matched in REVIEWS.io, so whatever
    // comes back is store-wide and has to be labelled as such.
    storeWide = !skus;

    adUgcAliases(root.dataset.ugcAliasUrl, skus)
      .then(function (extra) {
        if (extra) skus = skus ? skus + ';' + extra : extra;
        return adUgcFetch(adUgcEndpoint(store, skus, limit));
      })
      .then(function (data) {
        photos = adUgcWithoutHidden(adUgcCollect(data), root.dataset.ugcHide);
        if (photos.length || root.dataset.ugcFallback !== '1') return null;
        // Store-wide there are far more photos than videos, and the videos are
        // all older, so a plain date-sorted page of media never contains one.
        // Pull the videos separately and lead with them.
        return Promise.all([
          adUgcFetch(adUgcEndpoint(store, '', limit, 'videos')),
          adUgcFetch(adUgcEndpoint(store, '', limit, 'media'))
        ]).then(function (responses) {
          photos = adUgcWithoutHidden(adUgcDedupe(adUgcCollect(responses[0]).concat(adUgcCollect(responses[1]))), root.dataset.ugcHide);
          storeWide = photos.length > 0;
          return null;
        });
      })
      .then(paint)
      .catch(function () {
        if (designMode) showNote('Could not reach REVIEWS.io. The block hides itself on the live storefront when there is nothing to show.');
      });

    function showNote(text) {
      root.hidden = false;
      note.textContent = text;
      note.hidden = false;
    }

    function paint() {
      if (!photos.length) {
        if (designMode) showNote('No customer photos for this product yet. This block hides itself on the live storefront.');
        return;
      }
      root.hidden = false;
      var videoCount = photos.filter(function (item) { return item.type === 'video'; }).length;
      var photoCount = photos.length - videoCount;
      var parts = [];
      if (photoCount) parts.push(photoCount + (photoCount === 1 ? ' photo' : ' photos'));
      if (videoCount) parts.push(videoCount + (videoCount === 1 ? ' video' : ' videos'));
      count.textContent = parts.join(' · ');
      if (storeWide && root.dataset.ugcFallbackNote) showNote(root.dataset.ugcFallbackNote);
      appendTiles();
      moreButton.addEventListener('click', appendTiles);
    }

    function appendTiles() {
      var stop = Math.min(photos.length, rendered + pageSize);
      var fragment = document.createDocumentFragment();
      for (var i = rendered; i < stop; i += 1) fragment.appendChild(buildTile(photos[i], i));
      grid.appendChild(fragment);
      rendered = stop;
      if (rendered < photos.length) {
        moreButton.hidden = false;
        moreButton.textContent = 'Show ' + Math.min(pageSize, photos.length - rendered) + ' more';
      } else {
        moreButton.hidden = true;
      }
    }

    function buildTile(photo, index) {
      var item = document.createElement('li');
      item.className = 'product__ugc-tile';

      var noun = photo.type === 'video' ? 'video' : 'photo';
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', 'Open customer ' + noun + ' from ' + photo.author);

      var thumb = document.createElement('img');
      thumb.src = adUgcMediaUrl(photo.file, 400);
      thumb.loading = 'lazy';
      thumb.decoding = 'async';
      thumb.alt = 'Customer ' + noun + ' from ' + photo.author;
      button.appendChild(thumb);

      if (photo.type === 'video') {
        var play = document.createElement('span');
        play.className = 'product__ugc-tile-play';
        var glyph = document.createElement('span');
        glyph.textContent = '\u25B6';
        play.appendChild(glyph);
        button.appendChild(play);
      }

      if (photo.rating) {
        var badge = document.createElement('span');
        badge.className = 'product__ugc-tile-rating';
        badge.textContent = photo.rating + '★';
        button.appendChild(badge);
      }

      button.addEventListener('click', function () { open(index, button); });
      item.appendChild(button);
      return item;
    }

    function open(index, trigger) {
      lastFocus = trigger || document.activeElement;
      show(index);
      lightbox.hidden = false;
      document.body.classList.add('ad-ugc-open');
      document.addEventListener('keydown', onKeydown);
      lightbox.querySelector('[data-ugc-close]').focus();
    }

    function close() {
      video.pause();
      lightbox.hidden = true;
      document.body.classList.remove('ad-ugc-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function show(index) {
      current = (index + photos.length) % photos.length;
      var photo = photos[current];
      video.pause();
      if (photo.type === 'video') {
        image.hidden = true;
        image.removeAttribute('src');
        video.hidden = false;
        video.poster = adUgcMediaUrl(photo.file, 1200);
        video.src = adUgcVideoUrl(photo.video);
        source.textContent = 'Video submitted with a verified REVIEWS.io review';
      } else {
        video.hidden = true;
        video.removeAttribute('src');
        image.hidden = false;
        image.src = adUgcMediaUrl(photo.file, 1200);
        image.alt = 'Customer photo from ' + photo.author;
        source.textContent = 'Photo submitted with a verified REVIEWS.io review';
      }
      stars.textContent = photo.rating ? adUgcStars(photo.rating) : '';
      body.textContent = photo.body;
      body.hidden = !photo.body;
      author.textContent = photo.author;
      date.textContent = photo.date ? '· ' + photo.date : '';
      if (storeWide && photo.productName && photo.productLink) {
        productLink.textContent = photo.productName;
        productLink.href = photo.productLink;
        productLink.hidden = false;
      } else {
        productLink.hidden = true;
      }
      var single = photos.length < 2;
      previous.disabled = single;
      next.disabled = single;
    }

    function onKeydown(event) {
      if (event.key === 'Escape') { close(); return; }
      // The video element owns the arrow keys while it is focused (seek).
      if (document.activeElement === video) return;
      if (event.key === 'ArrowLeft') { show(current - 1); return; }
      if (event.key === 'ArrowRight') show(current + 1);
    }

    lightbox.querySelectorAll('[data-ugc-close]').forEach(function (element) {
      element.addEventListener('click', close);
    });
    previous.addEventListener('click', function () { show(current - 1); });
    next.addEventListener('click', function () { show(current + 1); });
  }

  function bindAdUgc(root) {
    root.querySelectorAll('[data-ad-ugc]').forEach(setupAdUgc);
  }
  bindAdUgc(document);
  document.addEventListener('shopify:section:load', function (event) { bindAdUgc(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  // Recovery for a dead-end results page. Shopify has already rendered zero
  // results by the time this runs, so re-run the query through the same
  // rewrites predictive search uses (window.ADSearch, defined in the header)
  // and hop to the first variant that finds something. `search_from` marks the
  // hop so it can be announced and can never loop.
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }

    ready(function () {
      var root = document.querySelector('.search');
      if (!root || !window.ADSearch) return;

      var params = new URLSearchParams(window.location.search);
      var origin = params.get('search_from');
      var notice = root.querySelector('[data-search-notice]');
      var empty = root.querySelector('[data-search-empty]');

      // Keep separators out of /search on the way in.
      var form = root.querySelector('.search__form');
      var input = form && form.querySelector('input[name="q"]');
      if (form && input) {
        form.addEventListener('submit', function () {
          var normalised = window.ADSearch.normalise(input.value);
          if (normalised && normalised !== input.value.trim()) input.value = normalised;
        });
      }

      function escapeHtml(value) {
        var div = document.createElement('div');
        div.textContent = value == null ? '' : value;
        return div.innerHTML;
      }

      // A rewrite can be a wildcard form like `I* OR N*`. That belongs in the
      // query string, not in front of the customer — put their own words back
      // into the heading and the box, and say plainly that these are near
      // matches rather than exact ones.
      if (origin) {
        var heading = root.querySelector('.search__title');
        if (heading) heading.textContent = 'Search results for "' + origin + '"';
        if (input) input.value = origin;
        // suggest.json prefix-matches the last token; /search does not. If the
        // hop still landed on nothing, say nothing — the plain empty state is
        // more honest than "showing the closest results" over an empty grid.
        if (notice && !empty) {
          notice.innerHTML =
            'No exact match for <strong>' + escapeHtml(origin) + '</strong> — showing the closest results.';
          notice.hidden = false;
        }
      }

      // Only the first, un-rewritten visit may hop.
      if (!empty || origin !== null) return;

      var terms = empty.getAttribute('data-search-terms') || '';

      // A bare label is a prompt for a number, not a query to widen.
      if (window.ADSearch.isLabelOnly(terms)) {
        var text = empty.querySelector('.search__empty-text');
        if (text) {
          text.innerHTML =
            'Enter the item number after <strong>' + escapeHtml(terms.trim()) + '</strong> — ' +
            'for example <strong>' + escapeHtml(terms.trim()) + ' 9362617004651</strong>.';
        }
        return;
      }
      var variants = window.ADSearch.candidates(terms).filter(function (variant) {
        return variant !== terms.trim();
      });
      if (!variants.length) return;

      function attempt(index) {
        if (index >= variants.length) return;
        var variant = variants[index];
        var url = '/search/suggest.json?' + new URLSearchParams({
          q: variant,
          'resources[type]': 'product',
          'resources[limit]': '1',
          'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor,tag'
        }).toString();

        fetch(url)
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var results = (data.resources && data.resources.results) || {};
            if ((results.products || []).length) {
              window.location.replace(
                '/search?q=' + encodeURIComponent(variant) +
                '&type=product&search_from=' + encodeURIComponent(terms)
              );
              return;
            }
            attempt(index + 1);
          })
          .catch(function () { /* leave the empty state as rendered */ });
      }

      attempt(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-products')) {
    class RelatedProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        fetch(this.dataset.url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const inner = html.querySelector('related-products');
            if (inner && inner.innerHTML.trim().length) {
              this.innerHTML = inner.innerHTML;
            }
            this.dataset.loaded = 'true';
          })
          .catch(() => {});
      }
    }
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
